import type { LucideIcon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

interface UseCaseCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export default function UseCaseCard({ icon: Icon, title, description }: UseCaseCardProps) {
  const { theme } = useTheme();

  return (
    <article className="rounded-lg border bg-white p-5 shadow-sm" style={{ borderColor: theme.border, backgroundColor: theme.surface }}>
      <div className="mb-4 flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50">
          <Icon className="h-5 w-5" style={{ color: theme.primary }} />
        </div>
        <h3 className="mb-0 text-base font-bold" style={{ color: theme.text }}>
          {title}
        </h3>
      </div>
      <p className="mb-0 text-sm leading-6" style={{ color: theme.textSecondary }}>
        {description}
      </p>
    </article>
  );
}
